function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0-marketo{fill:#8A6FB2;}\r\n");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0-marketo",
  d: "M23.7,26.8H21c-0.7,0-1.3,0.5-1.5,1.2l-1.3,5.7c1.8,0.1,3.5,0.3,5.1,0.5l1.4-6.2 C24.8,27.3,24.4,26.8,23.7,26.8 M16.6,29.9h-2.7c-0.7,0-1.3,0.5-1.5,1.2l-0.6,2.5c0.4,0,0.9-0.1,1.3-0.1c1.3,0,2.6,0,3.8,0.1 l0.6-2.5C17.6,30.5,17.2,29.9,16.6,29.9 M30.6,24.1h-2.7c-0.7,0-1.3,0.5-1.5,1.2l-2.1,9c1.8,0.3,3.5,0.6,4.9,1l2.4-10.1 C31.6,24.6,31.2,24.1,30.6,24.1 M38,19.4h-2.7c-0.7,0-1.3,0.5-1.5,1.2l-3.5,15.1c1.9,0.6,3.5,1.2,4.7,1.8l4-17 C39.1,19.9,38.7,19.4,38,19.4"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0-marketo",
  d: "M26.2,49.4c-11.8,0-21.3-9.6-21.3-21.3c0-11.8,9.6-21.3,21.3-21.3s21.3,9.6,21.3,21.3 C47.6,39.9,38,49.4,26.2,49.4z M26.2,9.6C16,9.6,7.7,17.9,7.7,28.1c0,10.2,8.3,18.5,18.5,18.5s18.5-8.3,18.5-18.5 C44.8,17.9,36.5,9.6,26.2,9.6z"
}))));

const SvgMarketo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 53 50.5",
  style: {
    enableBackground: "new 0 0 53 50.5"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marketo.125a891f.svg";
export { ForwardRef as ReactComponent };